<template>
	<layout-main-component class="user-profile" :class="routeName()">
		<h1 slot="header">{{ $t('base.general.user_profile') }}</h1>
		<div class="user-profile-menu">
			<router-link :to="{ name: 'UserProfileAccount' }" class="btn" active-class="btn-primary">{{ $t('base.profile.account_information') }}</router-link>
			
			<!--router-link :to="{ name: 'UserProfilePaymentMethods' }" class="btn" active-class="btn-primary">{{ $t('base.profile.payment_methods') }}</router-link>
			<router-link :to="{ name: 'UserProfileCurrentPlan' }" class="btn" active-class="btn-primary">{{ $t('base.profile.current_plan') }}</router-link>
			<router-link :to="{ name: 'UserProfileProPlan' }" class="btn" active-class="btn-primary">{{ $t('base.profile.pro_plan') }}</router-link-->

			<router-link :to="{ name: 'UserProfileSubscriptions' }" class="btn" active-class="btn-primary">{{ $t('labels.general.subscriptions') }}</router-link>
			<!--<router-link :to="{ name: 'UserProfileBudget' }" class="btn" active-class="btn-primary">{{ $t('labels.general.budget') }}</router-link>-->

			<router-link :to="{ name: 'UserProfileNotifications' }" class="btn" active-class="btn-primary">{{ $t('base.profile.notifications') }}</router-link>
			<router-link :to="{ name: 'UserProfileOrganizations' }" class="btn" active-class="btn-primary">{{ $t('labels.general.organization') }}</router-link>
			<router-link :to="{ name: 'UserProfileStaff' }" class="btn" active-class="btn-primary">{{ $t('base.profile.staff') }}</router-link>
			<router-link :to="{ name: 'UserProfileSynchronization' }" class="btn" active-class="btn-primary">{{ $t('base.profile.synchronization') }}</router-link>
		</div>
		<router-view/>
	</layout-main-component>
</template>

<script>
export default {
	methods: {
		routeName () {
			// return route name, converted from camelcase to dash (hyphen)
			return this.$route.name.replace(/([a-zA-Z])(?=[A-Z])/g, '$1-').toLowerCase()
		}
	}
}
</script>



// WEBPACK FOOTER //
// src/components/user/UserProfile.vue